export const network = {
    accessLog: 'Network access log',
    viewAccessLog: 'View access log',
    accessLogHint: 'Successful profile views, newest first. Self-views and search results are excluded.',
    loadingViews: 'Loading profile views…',
    noProfileViews: 'No profile views yet',
    noProfileViewsHint: 'Visits will appear here when other network participants open this profile.',
    loadViewsError: 'Profile views could not be loaded.',
    newestViews: 'Newest views',
    olderViews: 'Older views',
    title: 'Network',
    viewNetwork: 'View network',
    description: 'Find and connect with people in your organizations.',
    participationRequired: 'Join this organization’s network to see other profiles. Open your profile to review the information you share and give your consent.',
    chooseOrganization: 'Choose an organization',
    search: 'Search names and shared profile information',
    filters: 'Filters',
    empty: 'No matching profiles',
    emptyMessage: 'Try another search or change your filters.',
    unavailable: 'This network is unavailable',
    unavailableMessage: 'The network may be disabled or your access may have changed.',
    noValue: 'Not provided',
    yes: 'Yes',
    no: 'No',
    retry: 'Retry',
    all: 'All',
    profileViewsPage: {
        refresh: 'Refresh',
        title: 'Profile views',
        action: 'Who viewed my profile',
    },
    join: {
        title: 'Join the network',
        action: 'Join network',
        description: 'Review your profile above and choose which optional information you want to share with other network participants.',
        sharedFields: 'Your name is always shared. Other required fields: {{fields}}.',
        nameOnly: 'none',
        optionalFields: 'Optional shared information',
        reciprocalHint: 'You can only see optional information that you also share yourself.',
        consentTitle: 'Consent to participation',
        privacy: 'Read privacy notice',
        privacyError: 'The privacy notice could not be opened.',
        withdrawal: 'You can withdraw your consent by leaving the network in your linked contact’s details.',
        managedWithdrawal: 'To withdraw your consent and leave the network, contact your organization.',
        accept: 'I agree to participate',
        saved: 'You have joined the network.',
    },
    profilePage: {
        manageMyProfile: 'Manage my profile',
        saved: 'Saved',
        title: 'Profile',
        profileDetails: 'Profile details',
        contactDetails: 'Contact details',
        reviewed: 'Last confirmed',
        reviewPrompt: 'Please review your profile and confirm that your information is up to date.',
        confirmReview: 'Confirm profile is up to date',
        preview: 'Not shared yet. This preview is only visible to you until you join the network.',
        editContact: 'Edit contact details',
        visibleFields: 'Choose visible properties',
        leave: {
            action: 'Leave the network',
            description: 'Your profile will be hidden from the network. You can join again by accepting participation.',
        },
    },
    customFields: 'Custom fields',
    errors: {
        selfJoin: 'Your organization does not allow self-service joining.',
        consentChanged: 'The participation terms have changed. Review the updated information and try again.',
        profileViewLimit: 'You have reached your limit of {{limit}} profiles per 24 hours. You can open another profile from {{availableAt}}. Profiles you have already viewed remain available.',
        viewInProgress: 'Another profile is being opened. Please try again in a moment.',
        optOut: 'Your organization manages withdrawal of network consent. Please contact them.',
        access: 'You do not have access to this network.',
        consent: 'Join this network before viewing other profiles.',
        field: 'This field is unavailable or cannot be changed here.',
        invalid: 'Please check your entries.',
    },
}
